<template>
  <a-drawer width="65%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <page-header-wrapper>
      <a-card :bordered="false">
        <!-- 增加修改 -->
        <create-form
          ref="createForm"
          @ok="getList"
        />
        <!-- 数据展示 -->
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :pagination="false"
          :bordered="tableBordered"
        >

          <img style="width: 48px;height: 48px;" preview="模板图片" :src="record.templateImage" v-if="record.templateImage != null && record.templateImage != ''" slot="templateImage" slot-scope="text, record">

          <img style="width: 48px;height: 48px;" preview="原图章" :src="record.originalSeal" v-if="record.originalSeal != null && record.originalSeal != ''" slot="originalSeal" slot-scope="text, record">

          <img style="width: 48px;height: 48px;" preview="当前图章" :src="record.seal" v-if="record.seal != null && record.seal != ''" slot="seal" slot-scope="text, record">

          <span slot="createTime" slot-scope="text, record">
            {{ parseTime(record.createTime) }}
          </span>
          <span slot="operation" slot-scope="text, record">
            <a @click="$refs.createForm.handleUpdate(record, undefined)">
              <a-icon type="edit" />修改
            </a>
            <a-divider type="vertical" />
            <a @click="toSyncSeal(record.id)">
              <a-icon type="edit" />转化图章
            </a>
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </a-card>
    </page-header-wrapper>
  </a-drawer>

</template>

<script>
import { pageCompetitionCertificate,syncSeal, delCompetitionCertificate } from '@/api/platform/competitionCertificate'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CompetitionCertificate',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      open: false,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        competitionId: null,
        templateId: null,
        templateImage: null,
        awardsName: null,
        issueUnit: null,
        competitionTitle: null,
        originalSeal: null,
        seal: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '主键',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '赛事编号',
        //   dataIndex: 'competitionId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '模板名称',
          dataIndex: 'templateName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '模板图片',
          dataIndex: 'templateImage',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: "templateImage"}
        },
        // {
        //   title: '获奖称号',
        //   dataIndex: 'awardsName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '发证单位',
          dataIndex: 'issueUnit',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '赛事标题',
          dataIndex: 'competitionTitle',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '原图章',
          dataIndex: 'originalSeal',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: "originalSeal"}
        },
        {
          title: '图章',
          dataIndex: 'seal',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: "seal"}
        },
        // {
        //   title: '插入时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
   // this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onClose () {
      this.open = false
    },
    toSyncSeal(id){
      syncSeal({"id":id}).then(response => {
        this.$message.success(
          response.message,
          3
        )
        this.getList()
      }).finally(() => {
        this.submitLoading = false
      })
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    show (row) {
      this.queryParam.competitionId = row.id;
      this.open = true
      this.getList();
    },
    /** 查询赛事证书信息列表 */
    getList () {
      this.loading = true
     pageCompetitionCertificate(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        competitionId: undefined,
        templateId: undefined,
        templateImage: undefined,
        awardsName: undefined,
        issueUnit: undefined,
        competitionTitle: undefined,
        originalSeal: undefined,
        seal: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delCompetitionCertificate(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('platform/competition-certificate/export', {
            ...that.queryParam
          }, `赛事证书信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
